import React, { Fragment, useCallback, useRef, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import { FormBlock, PlaceHolderInject } from '../../types/general';
import * as Schema from '../../types/schema';
import CollapsableMenu from '../../components/CollapsableMenu/CollapsableMenu';
import { DefaultBlockWrapper, PropsDriller } from './Form';
import Row from './Row';

function Tabs(props: FormBlock<Schema.Tabs>) {
	const { schema, options = {} } = props;
	const { BlockWrapper = DefaultBlockWrapper } = options;
	const [placeHolder, setPlaceHolder] = useState<PlaceHolderInject>();
	const [activeTab, setActiveTab] = useState(schema.defaultActiveTabId || (schema.tabs ? schema.tabs[0].id : ''));
	const id = schema.id || 'root';
	const drill = PropsDriller(props);

	const onPlaceHolder = useCallback((args: PlaceHolderInject) => {
		setPlaceHolder(args);
	}, []);
	const tabs = (schema.tabs || []).filter((tab) => !tab.hidden);
	if (tabs.length === 0) return null;
	return (
		<BlockWrapper id={id} type='tabs' schema={schema} onPlaceHolder={onPlaceHolder}>
			<Tab.Container id={id} activeKey={activeTab}>
				{tabs && tabs.length > 1 && (
					<CollapsableMenu
						tabs={tabs}
						defaultActiveTabId={schema.defaultActiveTabId || ''}
						activeTabId={activeTab || ''}
						baseTabId={`${activeTab}-tabpane`}
						onSelect={(k) => setActiveTab(k)}
					/>
				)}
				<Tab.Content>
					{tabs && tabs.length > 0
						? tabs.map((tab) => {
								return (
									<Tab.Pane key={id + '-' + tab.id} id={tab.id} eventKey={tab.id} role='tabpanel'>
										{!tab.rows || (tab.rows.length === 0 && placeHolder && placeHolder.element)}
										{tab.rows && tab.rows.length > 0
											? tab.rows.map((row) => {
													return (
														<Fragment key={row.id}>
															{placeHolder &&
																placeHolder.before === row.id &&
																placeHolder.element}
															<Row schema={row} {...drill} />
															{placeHolder &&
																placeHolder.after === row.id &&
																placeHolder.element}
														</Fragment>
													);
											  })
											: null}
									</Tab.Pane>
								);
						  })
						: null}
				</Tab.Content>
			</Tab.Container>
		</BlockWrapper>
	);
}

export default Tabs;
